import NoValueCheck from './NoValueCheck';

/**
 * ตรวจสอบค่า น้ำตาลในเลือด (FBS/FPG)
 * Note: medium.json ไม่มีข้อมูลสำหรับน้ำตาลในเลือด ใช้ hard-coded values
 */
export default (value) => {
  const noValueResult = NoValueCheck(value);
  if (noValueResult) {
    return noValueResult;
  }

  const numericValue = parseFloat(value);

  if (isNaN(numericValue)) {
    return {
      title: 'ไม่พบข้อมูล',
      color: 'gray',
      caption: 'ข้อมูลไม่ถูกต้อง',
      suggest: ''
    };
  }

  // ค่าปกติ: 70-100 mg/dL (ขณะอดอาหาร)
  if (numericValue >= 70 && numericValue <= 100) {
    return {
      title: 'น้ำตาลในเลือดปกติ',
      color: 'green',
      caption: `น้ำตาลในเลือดอยู่ในเกณฑ์ปกติ (70-100 mg/dL)`,
      suggest: ''
    };
  } else if (numericValue < 70) {
    return {
      title: 'น้ำตาลในเลือดต่ำกว่าปกติ',
      color: 'red',
      caption: `น้ำตาลในเลือดต่ำกว่าปกติ (ค่าปกติ: 70-100 mg/dL)`,
      suggest: 'แนะนำให้ปรึกษาแพทย์'
    };
  } else {
    return {
      title: 'น้ำตาลในเลือดสูงกว่าปกติ',
      color: 'red',
      caption: `น้ำตาลในเลือดสูงกว่าปกติ (ค่าปกติ: 70-100 mg/dL)`,
      suggest: 'แนะนำให้ปรึกษาแพทย์'
    };
  }
};
